<template>
  <div>
    <help-info-wrapper
      :info.sync="helpData"
      :service-name="serviceName"
      class="warp"
    >
      <template>
        <v-expansion-panels class="px-4" flat>
          <v-expansion-panel
            v-for="(item, index) in customComponents"
            :key="index"
            :disabled="loading"
            class="mb-4"
          >
            <v-expansion-panel-header class="text-right">
              <div class="d-flex justify-space-between align-center">
                <div>
                  <v-icon class="me-2">mdi-{{ item.icon }}</v-icon>
                  {{ item.title }}
                </div>
                <help-info
                  :element-name="`${serviceName}-${componentName}-${item.name}-${item.title}`"
                  :label="item.title"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="ms-2"
                />
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="py-5">
              <component
                :is="item.name"
                :key="item.model"
                v-model="value[item.model]"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
    </help-info-wrapper>
  </div>
</template>

<script>
import HelpInfo from "./helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "./helpAcordion/HelpInfoWrapper.vue";
import DesignSamples from "./designSamples";
import MarkerRadius from "./markerRadius";
import MarkerCenter from "./markerCenter";
import QrFrame from "./qrFrame";
import QrColors from "../qrColors";
import QrMarkOut from "@/view/pages/qrland/components/qrMarkOut";
import LogoImg from "@/view/pages/qrland/components/logoImg";
import { getLanguageCookie } from "../../../../core/plugins/TitleRibbon/utils/languageCookie";

export default {
  name: "qrCustomize",

  components: {
    LogoImg,
    QrMarkOut,
    QrColors,
    QrFrame,
    MarkerCenter,
    MarkerRadius,
    DesignSamples,
    HelpInfo,
    HelpInfoWrapper,
  },

  props: {
    value: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    serviceName: {
      type: String,
      default: "Qrland",
    },
    componentName: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      helpData: [],
      customComponents: [
        {
          name: "DesignSamples",
          value: "",
          title: "",
          subtitle: "",
          icon: "qrcode-edit",
          model: "qrStyleColors",
        },
        {
          name: "MarkerCenter",
          value: "",
          title: "",
          subtitle: "",
          icon: "qrcode-edit",
          model: "MarkerCenter",
        },
        {
          name: "QrMarkOut",
          value: "",
          title: "",
          subtitle: "",
          icon: "qrcode-edit",
          model: "QrMarkOut",
        },
        {
          name: "QrFrame",
          value: "",
          title: "",
          subtitle: "",
          icon: "qrcode-edit",
          model: "QrFrame",
        },
        {
          name: "LogoImg",
          value: "",
          title: "",
          subtitle: "",
          icon: "qrcode-edit",
          model: "LogoImg",
        },
      ],
      qrDesign: {
        qrStyleColors: {
          backcolor: "",
          frontColor: "",
          gradient_color: "",
          gradient: false,
          pattern: "default",
        },
        MarkerCenter: {
          topRight: "",
          bottomLeft: "",
          main: "",
          different_markers_color: false,
          eyePattern: "default",
        },
        QrMarkOut: {
          topRight: "",
          bottomLeft: "",
          markOutPattern: "default",
          main: "",
          different_markers_color: false,
        },
        QrFrame: {
          main: "",
          text: "",
          framePattern: "none",
          different_markers_color: false,
        },
        LogoImg: {
          noBg: false,
          logoSize: 100,
          logoImg: "none",
        },
      },
    };
  },

  watch: {
    qrDesign: {
      handler(value) {
        this.$emit("input", value);
      },
      deep: true,
    },
    "$i18n.locale": {
      handler() {
        this.updateTransition();
        this.$forceUpdate();
      },
      immediate: true,
    },
  },

  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
    if (this.$route.name !== "qr.id.design") {
      this.qrDesign = {
        qrStyleColors: {
          backcolor: "",
          frontColor: "",
          gradient_color: "",
          gradient: false,
          pattern: "default",
        },
        MarkerCenter: {
          topRight: "",
          bottomLeft: "",
          main: "",
          different_markers_color: false,
          eyePattern: "default",
        },
        QrMarkOut: {
          topRight: "",
          bottomLeft: "",
          markOutPattern: "default",
          main: "",
          different_markers_color: false,
        },
        QrFrame: {
          main: "",
          text: "",
          framePattern: "none",
          different_markers_color: false,
        },
        LogoImg: {
          noBg: false,
          logoSize: 100,
          logoImg: "none",
        },
      };
    }
    this.updateTransition();
  },

  methods: {
    updateTransition() {
      this.customComponents[0].title = this.$t("qr_design_size");
      this.customComponents[1].title = this.$t("qr_eye_design");
      this.customComponents[2].title = this.$t("qr_markout");
      this.customComponents[3].title = this.$t("frame");
      this.customComponents[4].title = this.$t("logo");
      this.qrDesign.QrFrame.text = this.$t("scan_me");
    },
  },
};
</script>

<style scoped>
.v-expansion-panel {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #f49d1a;
}

.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #001554 !important;
  border-radius: 15px !important;
  color: whitesmoke !important;
}

.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active
  .v-icon {
  color: whitesmoke !important;
}
</style>
